<section class="footer-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
			<!-- ngIf: enableTalentCommunity == 'yes' -->
				<div class="copy">© Bizongo All rights reserved | Powered by <a  title="Home" target="_blank"  aria-label="Zwayam" rel="noopener"  href="https://zwayam.com"><img src="assets/powered-by-zwayam.png" alt="powered-by-zwayam" height="35" width="105" loading="lazy"> </a> </div>
			</div>
		</div>
	</div>
</section>